import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../components/info/DisplayError';
import Loading from '../../../components/info/Loading';
import { CreditLiquidationFormDataResponse } from '../types';
import { getCreditLiquidationFormData } from '../api';

export interface CreditLiquidationFilterLoaderProps {
  children: ReactElement | ReactElement[];
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  CreditLiquidationFormDataResponse
>();

export function useCreditLiquidationFilterLoader() {
  return useFetch();
}

export const CreditLiquidationFilterLoaderConsumer = FetchConsumer;

export default function CreditLiquidationFilterLoader({
  children,
}: CreditLiquidationFilterLoaderProps) {
  const request = useCallback(() => {
    return getCreditLiquidationFormData();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="No se pudieron cargar los datos del formulario"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return <>{children}</>;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
